import React from 'react'

export enum TicketVariant {
  Promoted = 'promoted',
  SoldOut = 'soldOut',
  Standard = 'standard',
}

const TicketVariantContext = React.createContext({
  variant: TicketVariant.Standard,
})

export default TicketVariantContext
